import { useState } from "react";
import { Chip } from "@mui/material";
import CustomDataGridV2 from "../../../../components/CustomDataGridV2";
import Text from "../../../../components/Text";
import {
  applyDefaultColumnSettings,
  DEF_PAGINATION,
  DGT_Pagination,
} from "../../../../utils/utils";

const PaymentHistory = () => {
  const dummyData = [
    {
      uuid: "1",
      invoiceNumber: "INV-2025-01",
      serviceVisitType: "Consultation",
      provider: "Dr. Lilly Turner",
      serviceDate: "02 Aug 2025",
      amount: "$200",
      paidOn: "05 Aug 2025",
      status: "Paid",
    },
    {
      uuid: "2",
      invoiceNumber: "INV-2025-02",
      serviceVisitType: "Physiotherapy Session 1",
      provider: "Dr. Corina",
      serviceDate: "05 Aug 2025",
      amount: "$250",
      paidOn: "10 Aug 2025",
      status: "Paid",
    },
    {
      uuid: "3",
      invoiceNumber: "INV-2025-03",
      serviceVisitType: "X-Ray - Chest",
      provider: "Dr. Corina",
      serviceDate: "28 Jul 2025",
      amount: "$300",
      paidOn: "01 Aug 2025",
      status: "Paid",
    },
    {
      uuid: "4",
      invoiceNumber: "INV-2025-04",
      serviceVisitType: "Telehealth Follow-up",
      provider: "Dr. Lilly Turner",
      serviceDate: "20 Jul 2025",
      amount: "$150",
      paidOn: "25 Jul 2025",
      status: "Paid",
    },
    {
      uuid: "5",
      invoiceNumber: "INV-2025-05",
      serviceVisitType: "Physiotherapy Session 2",
      provider: "Dr. Corina",
      serviceDate: "12 Jul 2025",
      amount: "$180",
      paidOn: "10 Aug 2025",
      status: "Paid",
    },
  ];

  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const columns = applyDefaultColumnSettings([
    {
      field: "invoiceNumber",
      headerName: "Invoice Number",
      flex: 1,
    },
    {
      field: "serviceVisitType",
      headerName: "Service/ Visit Type",
      flex: 1,
    },
    {
      field: "provider",
      headerName: "Provider",
      flex: 1,
    },
    {
      field: "serviceDate",
      headerName: "Service Date",
      flex: 1,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
    },
    {
      field: "paidOn",
      headerName: "Paid On",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: ({ row }: { row: any }) => (
        <Chip
          size="small"
          label={row?.status}
          sx={{
            bgcolor: "#E4F8E7",
            color: "#00B917",
            fontWeight: 500,
          }}
        />
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.5,
      renderCell: () => (
        <Text
          color="primary.main"
          sx={{ cursor: "pointer", textDecoration: "underline" }}
        >
          View Receipt
        </Text>
      ),
    },
  ]);

  return (
    <CustomDataGridV2
      getRowId={(row) => row?.uuid}
      rows={dummyData ?? []}
      rowCount={dummyData?.length ?? 10}
      columns={columns}
      paginationModel={pagination}
      onPaginationModelChange={setPagination}
    />
  );
};

export default PaymentHistory;
